import { Box, styled } from '@mui/material';

export const StyledDiscoveryTile = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'label',
})<{ label: string }>(({ theme, label }) => ({
  position: 'relative',
  aspectRatio: '1/1',
  borderRadius: theme.spacing(1),
  overflow: 'hidden',
  '&:after': {
    opacity: 0,
    position: 'absolute',
    bottom: theme.spacing(2),
    width: '100%',
    textAlign: 'center',
    fontWeight: 700,
    content: `"${label}"`,
    pointerEvents: 'none',
    transition: 'opacity 0.3s ease-in-out',
  },
  [`&:hover:after`]: {
    opacity: 1,
  },
  '&:hover > img': {
    opacity: 0.7,
  },
}));

export const StyledTagsGridItemImage = styled('img')(() => ({
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  transition: 'opacity 0.3s ease-in-out',
}));

export const StyledInner = styled(Box)(() => ({
  position: 'absolute',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
}));
